'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className"];
import classNames from 'classnames';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIAbstractPageSection(props) {
  const {
      className
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("section", Object.assign({}, rest, {
    "aria-label": I18n.text('ui.UIAbstractPageSection.page'),
    className: classNames('private-template__section', className)
  }));
}
UIAbstractPageSection.propTypes = {
  children: PropTypes.node
};
UIAbstractPageSection.displayName = 'UIAbstractPageSection';